import { NlpModelId } from '@feedyou-ai/feedbot-schema'

import { TrainingDataDescription } from './components/TrainingDataDescription'
import { SchemaInlinedDescription } from '../../../design-system/FeedbotRjsfForm'

export const schema = {
  type: 'object',
  properties: {
    testData: {
      type: 'string',
      description: <TrainingDataDescription />
    },
    testAgainstModels: {
      type: 'object',
      discriminator: { propertyName: 'mode' },

      oneOf: [
        {
          type: 'object',
          title: (
            <>
              Test each test case in all models{' '}
              <SchemaInlinedDescription
                description={
                  <>
                    This is useful when all models are allowed globally. <br /> <br />
                    Models can be disallowed in a context by using the 'Allowed in dialogs',
                    'Disallowed in dialogs' and 'Disallowed in step IDs' options in NLP settings.{' '}
                  </>
                }
              />
            </>
          ),
          properties: { mode: { type: 'string', const: 'ALL', default: 'ALL' } }
        },
        {
          type: 'object',
          title: (
            <>
              Test each test case only in the model you expect to be matched{' '}
              <SchemaInlinedDescription
                description={
                  <>
                    This is useful when you only allow one model in each context. <br /> <br />
                    Models can be disallowed in a context by using the 'Allowed in dialogs',
                    'Disallowed in dialogs' and 'Disallowed in step IDs' options in NLP settings.{' '}
                  </>
                }
              />
            </>
          ),
          properties: { mode: { type: 'string', const: 'EXPECTED', default: 'EXPECTED' } }
        },
        {
          type: 'object',
          title: (
            <>
              Test each test case in the following models:{' '}
              <SchemaInlinedDescription description="Select models to test your test cases in. Each of your test cases will be tested in all of the selected models." />
            </>
          ),
          description: 'Select models to test in:', // This gets displayed below radio, so we use it as a heading for the contents below
          properties: {
            mode: { type: 'string', const: 'CHOOSE', default: 'CHOOSE' },
            chosenModels: {
              type: 'array',
              uniqueItems: true, // No idea why, but this is required for checkboxes to work
              minItems: 1,
              items: {
                type: 'string',
                // Populated programmatically todo: maybe find a way to populate from definitions, and populate those programmatically once for whole app
                anyOf: [] as Array<{ const: NlpModelId; title: string }>
              },
              default: [] as NlpModelId[]
            }
          },
          required: ['chosenModels']
        }
      ]
    }
  }
} as const

export type Schema = typeof schema

export type FormData = {
  testData: string
  testAgainstModels:
    | { mode: 'ALL' }
    | { mode: 'EXPECTED' }
    | { mode: 'CHOOSE'; chosenModels: string[] }
}

export const defaultFormData: FormData = {
  testData: '',
  testAgainstModels: { mode: 'ALL' }
}

export const uiSchema = {
  'ui:label': false,
  'ui:order': ['testAgainstModels', 'testData'],
  testData: {
    'ui:classNames': 'hidden-title',
    'ui:widget': 'EditorWidget',
    'ui:forceDescriptionMode': 'inline',
    focus: true,
    isWrapTextEnabled: true,
    resizeCssRule: 'none',
    initialRowsCount: 46
  },
  testAgainstModels: {
    'ui:widget': 'radio',
    'ui:classNames': 'hidden-title mb0',
    'ui:title': false,
    mode: { 'ui:widget': 'hidden' },
    chosenModels: {
      'ui:widget': 'checkboxes'
    }
  }
}
